import React from 'react'
import PrivacyPolicy from '../privacy-policy'

const PrivacyPolicyPl = () => {
    return <PrivacyPolicy languageCode="pl" />
}

export default PrivacyPolicyPl
